import { Component, OnInit, Input } from '@angular/core';
import { RemoteAssessment } from 'app/model/remote-assessment';
import { NgWizardService } from 'ng-wizard';
import { ContextService } from 'app/services/context.service';
import { CrmService } from 'app/services/crm.service';
import { RemoteAnswer } from 'app/model/remote-answer';
import { ToastService } from 'app/services/toast.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css']
})
export class QuestionsComponent implements OnInit {
  isCollapsed = new Array();
  remoteAssessment: RemoteAssessment;
  isPostStepThreeReadOnlyWorkflow = false;
  private hasAttemptedRefreshFileHydration = false;
  private isRefreshFileHydrationInProgress = false;

  constructor(private ngWizardService: NgWizardService, private context: ContextService, private crmService: CrmService,private toastService:ToastService) {
    this.context.remoteAssessment.subscribe(ra => {
      this.remoteAssessment = ra;
      this.tryHydrateMissingFileNamesAfterRefresh();
    });
    this.context.postStepThreeReadOnlyWorkflow.subscribe(enabled => {
      this.isPostStepThreeReadOnlyWorkflow = enabled === true;
    });
  }

  ngOnInit(): void {
    this.tryHydrateMissingFileNamesAfterRefresh();
  }

  nextStep(){
    this.ngWizardService.next();
  }

  get showPreviousButton(): boolean {
    const isPsdLocked = this.remoteAssessment?.assessment?.isPSDLocked === true;
    return !isPsdLocked || this.isPostStepThreeReadOnlyWorkflow;
  }

  previousStep(){
    if (this.showPreviousButton) {
      this.ngWizardService.previous();
    }
  }

  hasFiles(hasFiles:boolean,answer:RemoteAnswer){
    answer.hasFiles = hasFiles;

  }

  saveAnswer(answer){
    this.crmService.SaveAnswer(answer).subscribe(x=>{
      this.toastService.showSuccess("Saved Successfully");
    })
  }

  private tryHydrateMissingFileNamesAfterRefresh() {
    if (this.hasAttemptedRefreshFileHydration || this.isRefreshFileHydrationInProgress) {
      return;
    }

    const answers = this.remoteAssessment?.remoteAnswer || [];
    if (answers.length === 0) {
      return;
    }

    const missingFileNameAnswers = answers.filter(a => !a.fileNames || a.fileNames.length === 0);

    // If fileNames are already present (normal Step 2 -> Step 3 flow), do nothing.
    if (missingFileNameAnswers.length === 0) {
      this.hasAttemptedRefreshFileHydration = true;
      return;
    }

    this.hasAttemptedRefreshFileHydration = true;
    this.isRefreshFileHydrationInProgress = true;

    const fileRequests = missingFileNameAnswers.map(answer =>
      this.crmService.GetDocument(answer.id).pipe(
        catchError(() => of([] as string[]))
      )
    );

    forkJoin(fileRequests).subscribe(results => {
      let hasChanges = false;

      results.forEach((files, index) => {
        const answer = missingFileNameAnswers[index];
        const normalizedFiles = files || [];

        if (!answer.fileNames || answer.fileNames.length !== normalizedFiles.length) {
          hasChanges = true;
        }

        answer.fileNames = normalizedFiles;
        answer.hasFiles = normalizedFiles.length > 0;
      });

      this.isRefreshFileHydrationInProgress = false;

      if (hasChanges) {
        this.context.updateContextRA(this.remoteAssessment);
      }
    }, _ => {
      this.isRefreshFileHydrationInProgress = false;
    });
  }

}
